import React, { useState } from 'react';
import { Menu, message } from 'antd';
import { useSelector } from 'react-redux';
import { useRouteMatch, useHistory } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
import { QuotesIcon, InvoiceIcon, HomeIcon, SettingsIcon, NotesIcon, CaseIcon, EmailIcon, SalesIcon, TaskIcon, ReportsIcon, ForecastIcon, CalendarIcon, AccountsIcon, LeadIcon, DealIcon, ContactIcon, CampaignIcon } from '../components/Icons/Icons';
import EditNavPopup from '../container/dashboard/Popup/EditNavPopup'

const { SubMenu } = Menu;

const MenuItems = ({ darkMode, toggleCollapsed, topMenu }) => {
  const history = useHistory();
  const localData = useSelector((state) => state.localRedux);
  const Role = localData.role
  const edit = useSelector((state) => state.edit.edit);
  const permission = localData.permissions
  const storeSubcription = localData.subcription
  const { path } = useRouteMatch();
  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');
  const [confirmPopup, setConfirmPopup] = useState(false)
  const [linkUrl, setLinkUrl] = useState()
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'Home'}`] : [],
  );
  const [permissionMenu] = useState(permission ? permission.menu : ['*'])
  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };
  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };
  const handleNavigationClick = (url) => {
    if (edit) {
      setConfirmPopup(true)
      setLinkUrl(url)
    }
  };
  const navigate = (url) => {
    history.push({
      pathname: url,
      state: { refresh: Date.now() }, // dummy state to trigger navigation
    });
  };
  const handleMenuNavigation = (url) => {
    if (storeSubcription?.isActive) {
      if (edit) {
        handleNavigationClick(url);
      } else {
        navigate(url);
      }
    } else {
      message.info("Your subscription is not active. Please renew to continue");
    }
  };
  const handleMenuNavigation1 = (url) => {
    if (storeSubcription?.isActive) {
      if (!edit) {
        navigate(url);
        toggleCollapsed();
      } else {
        handleNavigationClick(url);
      }
    } else {
      message.info("Your subscription is not active. Please renew to continue");
    }
  };
  // const urlPathname = window.location.pathname;
  // const urlSearch = window.location.search;
  // const combinedUrl = urlPathname + urlSearch;
  const canCreate = (rolePermissions, actionRoleId) => {
    if (!Array.isArray(rolePermissions)) return false;
    const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    return hasRolePermission;
  };

  const IconMenu = ({ pagelink, Icon }) => (
    <div className="menuItem-iocn" role="button"
      tabIndex={0}
      onClick={() => {
        handleMenuNavigation(`${path}${pagelink}`);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleMenuNavigation(`${path}${pagelink}`);
        }
      }}
      style={{ cursor: 'pointer' }}
    >
      <Icon />
    </div>

  );
  IconMenu.propTypes = {
    pagelink: propTypes.string.isRequired,
    Icon: propTypes.elementType.isRequired,
  };
  const NameMenu = ({ pagelink, Name }) => (
    <div tabIndex={0} role='button'
      onClick={() => {
        handleMenuNavigation1(`${path}${pagelink}`);
      }}
      style={{ cursor: 'pointer' }}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleMenuNavigation1(`${path}${pagelink}`);
        }
      }}
    >
      {Name}
    </div>
  );
  NameMenu.propTypes = {
    pagelink: propTypes.string.isRequired,
    Name: propTypes.string.isRequired,
  };

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
            }`,
          ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'Home'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >

      {Role !== "Super Admin" ? <>
        {canCreate(permissionMenu, 1001) &&
          // <Menu.Item key="home"
          //   icon={
          //     <NavLink className="menuItem-iocn" to={!edit ? `${path}` : combinedUrl} onClick={() => edit && handleNavigationClick(`${path}`)}>
          //       <HomeIcon />
          //     </NavLink>
          //   }>
          //   <NavLink onClick={() => !edit ? toggleCollapsed() : handleNavigationClick(`${path}`)} to={!edit ? `${path}` : combinedUrl}>
          //     Home
          //   </NavLink>
          // </Menu.Item>
          <Menu.Item key="home" icon={<IconMenu pagelink="" Icon={HomeIcon} />}>
            <NameMenu pagelink="" Name="Home" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1002) &&
          // <Menu.Item key="lead"
          //   icon={
          //     <NavLink className="menuItem-iocn" to={!edit ? `${path}/leads` : combinedUrl} 
          //     onClick={() => edit && handleNavigationClick(`${path}/leads`)}>
          //       <LeadIcon />
          //     </NavLink>
          //   }>
          //   <NavLink onClick={() => !edit ? toggleCollapsed() : handleNavigationClick(`${path}/leads`)} to={!edit ? `${path}/leads` : combinedUrl}>
          //     Leads
          //   </NavLink>
          // </Menu.Item>
          <Menu.Item key="lead" icon={<IconMenu pagelink="/leads" Icon={LeadIcon} />}>
            <NameMenu pagelink="/leads" Name="Leads" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1003) &&
          <Menu.Item key="contact" icon={<IconMenu pagelink="/contacts" Icon={ContactIcon} />}>
            <NameMenu pagelink="/contacts" Name="Contacts" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1004) &&
          <Menu.Item key="account" icon={<IconMenu pagelink="/accounts" Icon={AccountsIcon} />}>
            <NameMenu pagelink="/accounts" Name="Accounts" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1005) &&
          <Menu.Item key="deal" icon={<IconMenu pagelink="/deals" Icon={DealIcon} />}>
            <NameMenu pagelink="/deals" Name="Deals" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1006) &&
          <Menu.Item key="tasks" icon={<IconMenu pagelink="/tasks" Icon={TaskIcon} />}>
            <NameMenu pagelink="/tasks" Name="Tasks" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1007) &&
          <Menu.Item key="email" icon={<IconMenu pagelink="/email/inbox" Icon={EmailIcon} />}>
            <NameMenu pagelink="/email/inbox" Name="Email" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1008) &&
          <Menu.Item key="meeting" icon={<IconMenu pagelink="/meetings" Icon={CalendarIcon} />}>
            <NameMenu pagelink="/meetings" Name="Meetings" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1011) &&
          <Menu.Item key="forecast" icon={<IconMenu pagelink="/forecast" Icon={ForecastIcon} />}>
            <NameMenu pagelink="/forecast" Name="Forecast" />
          </Menu.Item>
        }
        {/* <Menu.Item
          key="chat"
          icon={
            <NavLink className="menuItem-iocn" to={`${path}/chat`}>
              <FeatherIcon icon="message-circle" />
            </NavLink>
          }
        >
          <NavLink to={`${path}/chat`} onClick={() => !edit ? toggleCollapsed() : handleNavigationClick(`${path}/chat`)}>
            Chat
          </NavLink>
        </Menu.Item> */}
        {canCreate(permissionMenu, 1012) &&
          <Menu.Item key="reports" icon={<IconMenu pagelink="/reports" Icon={ReportsIcon} />}>
            <NameMenu pagelink="/reports" Name="Reports" />
          </Menu.Item>
        }
        {canCreate(permissionMenu, 1009) &&
          <Menu.Item key="notes" icon={<IconMenu pagelink="/notes" Icon={NotesIcon} />}>
            <NameMenu pagelink="/notes" Name="Notes" />
          </Menu.Item>
        }
        <SubMenu key="more" icon={!topMenu && <FeatherIcon icon="more-horizontal" />} title="More"
          popupOffset={[2, -200]}
        >
          <Menu.Item key="quotes" icon={<QuotesIcon marginRight={10} />} style={{ display: "flex", alignItems: "center" }}>
            <NameMenu pagelink="/quotes" Name="Quotes" />
          </Menu.Item>
          <Menu.Item key="orderss" icon={<SalesIcon marginRight={10} />} style={{ display: "flex", alignItems: "center" }}>
            <NameMenu pagelink="/orders" Name="Sales Orders" />
          </Menu.Item>
          <Menu.Item key="invoices" icon={<InvoiceIcon marginRight={10} />} style={{ display: "flex", alignItems: "center" }}>
            <NameMenu pagelink="/invoices" Name="Invoices" />
          </Menu.Item>
          <Menu.Item key="cases" icon={<CaseIcon marginRight={10} />} style={{ display: "flex", alignItems: "center" }}>
            <NameMenu pagelink="/cases" Name="Cases" />
          </Menu.Item>
          <Menu.Item key="campaigns" icon={<CampaignIcon marginRight={10} />} style={{ display: "flex", alignItems: "center" }}>
            <NameMenu pagelink="/campaigns" Name="Campaigns" />
          </Menu.Item>
        </SubMenu>
        {canCreate(permissionMenu, 1013) &&
          <Menu.Item key="settings" icon={<IconMenu pagelink="/settings" Icon={SettingsIcon} />}>
            <NameMenu pagelink="/settings" Name="Settings" />
          </Menu.Item>
        }
      </>
        :
        <>
        </>}
      {confirmPopup && <EditNavPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} linkUrl={{ url: linkUrl, type: "Normal" }} />}
    </Menu >
  );
}

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
